import { cn } from '@/utils/cn'

type PulsingDotTone = 'warning' | 'success' | 'info'

const TONE_BG: Record<PulsingDotTone, string> = {
  warning: 'bg-warning',
  success: 'bg-success',
  info: 'bg-info',
}

const SIZE_OUTER: Record<'sm' | 'md', string> = {
  sm: 'size-2',
  md: 'size-2.5',
}

const SIZE_INNER: Record<'sm' | 'md', string> = {
  sm: 'size-1.5',
  md: 'size-2',
}

export interface PulsingDotProps {
  tone: PulsingDotTone
  size?: 'sm' | 'md'
  className?: string
}

export function PulsingDot({ tone, size = 'md', className }: PulsingDotProps) {
  const bg = TONE_BG[tone]
  return (
    <span
      className={cn(
        'relative flex shrink-0 items-center justify-center',
        SIZE_OUTER[size],
        className
      )}
    >
      <span
        className={cn('absolute inline-flex size-full animate-ping rounded-full opacity-60', bg)}
      />
      <span className={cn('relative inline-flex rounded-full', SIZE_INNER[size], bg)} />
    </span>
  )
}
